import { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import { AddressForm } from "src/components/common/form/address/AddressForm";
import { DropDownForm } from "src/components/common/form/DropdownForm";
import { AddressJusoDto } from "src/dtos/address/addressApiResponseDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";
import { BRDiv } from "src/components/common/common";
import { CodeForm } from "src/components/common/form/CodeForm";
import { InputForm } from "src/components/common/form/input/InputForm";
import { SingleDateForm } from "src/components/common/form/SingleDateForm";
import { handleKeyDown, syntheticEvent } from "src/utils/commonForm/commonFormUtils";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import {  searchCustomer } from "src/apis/customerApi";
import { getEmployeeList } from "src/apis/employeeApi";
import { defaultSAL1010_R01HeaderDto, SAL1010_R01DetailDto, SAL1010_R01HeaderDto } from "./Dto_SAL1010_R01";
import { useSAL1010_R01Store, } from "./Store_SAL1010_R01";
import { formatDate } from "src/utils/string/stringUtil";
import { isOrderLocked } from "src/utils/order/orderUtils";



interface Props {
	defaultSAL1010_R01HeaderRow: SAL1010_R01HeaderDto;
}

export const Info_SAL1010_R01 = (props: Props) => {

	const { defaultSAL1010_R01HeaderRow } = props;

	const { vatTypeList, moneyCdList, wmsCdList, warehouseCdList, compCdList } = useCommonCodeStore();
	const { setCodeSearchModalProps, setAddressModalProps } = useUiuxStore();
	const { 
		SAL1010_R01DetailList, 
		deletedSAL1010_R01DetailList,
		editSAL1010_R01, setEditSAL1010_R01,
	} = useSAL1010_R01Store();
	const isLocked = isOrderLocked(editSAL1010_R01?.orderStatus);

	// 직접 상태 업데이트 (SAL2020 패턴)



	const custInfoHandleFoucsId = 'infoCustInput';
	const addressHandleFoucsId = 'addressInput2';
	const empInfoHandleFoucsId = 'infoEmpInput'; // 영업담당 포커스 ID 추가

	// Info 폼 코드 검색 필드 설정
	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
				post: 'post',
				address: 'address',
				detailAddress: 'detailAddress',
				telNo: 'telNo',
				faxNo: 'faxNo',
				moneyCd: 'moneyCd',
				taxEmail: 'email',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			},
			extraFilter: () => ({
				customCd: editSAL1010_R01?.customCd || '',
				customNm: editSAL1010_R01?.customNm || '',
			}),
		},
		{
			fieldName: 'empNo',
			category: '사원번호',
			focusId: empInfoHandleFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm'
			},
			searchFunction: async (code: string) => {
				const employeeResponse = await getEmployeeList('all');
				return employeeResponse.data.data.find(value => value.empNo === code);
			},
			extraFilter: () => ({
				empNo: editSAL1010_R01?.empNo || '',
				empNm: editSAL1010_R01?.empNm || '',
			}),
		}
	];

	// Info 폼 이벤트 훅 사용
	const { getFieldHandlers } = useInfoFormEvents({
		editData: editSAL1010_R01,
		setEditData: setEditSAL1010_R01,
		defaultData: defaultSAL1010_R01HeaderRow,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'SAL1010_R01'
	});

	// 발주일자 달력 팝업 상태
	const [orderDtVisible, setOrderDtVisible] = useState(false);
	const [orderDtPickerPos, setOrderDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	// 납기일 달력 팝업 상태
	const [dueDtVisible, setDueDtVisible] = useState(false);
	const [dueDtPickerPos, setDueDtPickerPos] = useState<{top: number, left: number, height: number}>({top: 0, left: 0, height: 0});

	// 부가세 입력 포커스 상태 및 표시값 관리
	const [vatAmtInputFocused, setVatAmtInputFocused] = useState(false);
	const [vatAmtInputValue, setVatAmtInputValue] = useState('');
	// const [vatAmtManuallyEdited, setVatAmtManuallyEdited] = useState(false);

	const calculateAmtInfo = useCallback((vatTypeInput?: string) => {
		
		const editSAL1010_R01 = useSAL1010_R01Store.getState().editSAL1010_R01 || defaultSAL1010_R01HeaderRow;
		const newVatType = vatTypeInput || editSAL1010_R01?.vatType;

		const newOrderAmt = SAL1010_R01DetailList.reduce((sum, item) => 
			sum + (deletedSAL1010_R01DetailList.includes(item.valueIndex?.toString() || '') ? 0 : item.itemAmt), 0);

		let newVatAmt = editSAL1010_R01?.vatAmt || 0;

		const selectedVatType = vatTypeList.find(vat => vat.minorCd === newVatType);
		
		newVatAmt = Number(newOrderAmt || 0) * Number(selectedVatType?.ref01 || 0) / 100;

		setEditSAL1010_R01({
			...defaultSAL1010_R01HeaderRow,
			...editSAL1010_R01,
			vatType: vatTypeInput || editSAL1010_R01?.vatType,
			orderAmt: newOrderAmt,
			vatAmt: newVatAmt,
			totalAmt: newOrderAmt + newVatAmt
		})
		return newOrderAmt;
	}, [SAL1010_R01DetailList, deletedSAL1010_R01DetailList, editSAL1010_R01?.vatType]);

	// detail 변경시 수주금액 자동 계산 (상세 itemAmt 합계)
	useEffect(() => {
		calculateAmtInfo();
	}, [SAL1010_R01DetailList, vatTypeList, deletedSAL1010_R01DetailList, ])

	useEffect(() => {
		// editSAL1010_R01.vatAmt가 바뀌면 표시값도 갱신 (포커스 없을 때만)
		if (!vatAmtInputFocused) {
			setVatAmtInputValue(Number(editSAL1010_R01?.vatAmt || 0).toLocaleString());
		}
	}, [editSAL1010_R01?.vatAmt, vatAmtInputFocused]);

	const handleDateChange = useCallback((field: keyof SAL1010_R01HeaderDto, value: any) => {
		setEditSAL1010_R01({
			...defaultSAL1010_R01HeaderRow,
			...editSAL1010_R01,
			[field]: value
		});
	}, [editSAL1010_R01]);

	const handleChange = useCallback((e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		// 수주액 또는 부가세가 변경될 때 총액도 같이 변경
		if (name === 'orderAmt' || name === 'vatAmt') {
			const orderAmt = name === 'orderAmt' ? Number(value) : Number(editSAL1010_R01?.orderAmt ?? 0);
			const vatAmt = name === 'vatAmt' ? Number(value) : Number(editSAL1010_R01?.vatAmt ?? 0);
			
			setEditSAL1010_R01({
				...defaultSAL1010_R01HeaderRow,
				...editSAL1010_R01,
				[name]: Number(value),
				totalAmt: orderAmt + vatAmt
			});
			return;
		}

		// 부가세 구분이 변경될 때 자동 계산
		if (name === 'vatType') {
			calculateAmtInfo(value);
			return;
		}

		setEditSAL1010_R01({
			...defaultSAL1010_R01HeaderRow,
			...editSAL1010_R01,
			[name]: value
		});
	}, [editSAL1010_R01, vatTypeList, warehouseCdList, defaultSAL1010_R01HeaderRow]);

	const handleAddressSearchClick = () => {
		setAddressModalProps({
			onSelect: (data: AddressJusoDto) => {
				setEditSAL1010_R01({
					...defaultSAL1010_R01HeaderRow,
					...editSAL1010_R01,
					post: data.zipNo,
					address: data.roadAddr,
				})
				setAddressModalProps(undefined);
				handleKeyDown(syntheticEvent(addressHandleFoucsId), 'focus');
			},
			handleFoucsId: addressHandleFoucsId // 주소 검색 후 입력 포커스 이동을 위한 아이디
		})
	}

	return (
		<div className="w-full h-full flex flex-wrap content-start pt-[12px] pl-[12px] pr-[12px] pb-[6px] overflow-y-auto border border-gray-300">
				{/* editSAL1010_R01 : {JSON.stringify(editSAL1010_R01)} <br /> */}
				<InputForm 
					title="주문No" 
					value={editSAL1010_R01?.salesOrderNo || ""} 
					editable={false}
					name="salesOrderNo" 
					onChange={handleChange} 
				/>
				<InputForm 
					title="주문상태" 
					value={editSAL1010_R01?.orderStatus === 'E' ? '출고완료' : editSAL1010_R01?.orderStatus === 'P' ? '출고진행중' : '출고대기'} 
					editable={false}
					name="orderStatus" 
					onChange={() => {}} 
				/>
				<BRDiv />
				<SingleDateForm
					title="수주일자"
					value={editSAL1010_R01?.orderDt ? new Date(editSAL1010_R01.orderDt) : undefined}
					setValue={(value: Date | undefined) => handleDateChange('orderDt', formatDate(value))}
					editable={!isLocked}
					visible={orderDtVisible}				setVisible={setOrderDtVisible}
					onChange={handleChange}
					pickerPos={orderDtPickerPos}						setPickerPos={setOrderDtPickerPos}
				/>
				<DropDownForm
					title="사업장"
					name="compCd"
					initLabelLess={true}
					value={editSAL1010_R01?.compCd}
					data={compCdList}
					editable={!isLocked}
					onChange={handleChange}
				/>
				<BRDiv />
				<CodeForm
					label="거래처"
					value={editSAL1010_R01?.customCd || ""}
					custNmValue={editSAL1010_R01?.customNm || ""}
					editable={!isLocked}
					handleFoucsId={custInfoHandleFoucsId}
					name="customCd"
					handleChange={getFieldHandlers('customCd').onChange}
					onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
					onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
				/>
        		<CodeForm
					label="영업담당"
					value={editSAL1010_R01?.empNo || ""}
					custNmValue={editSAL1010_R01?.empNm || ""}
					editable={!isLocked}
					handleFoucsId={empInfoHandleFoucsId}
					name="empNo"
					handleChange={getFieldHandlers('empNo').onChange}
					onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
					onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
				/>
       
        		<BRDiv />
        		<InputForm 
					title="전화번호" 
					value={editSAL1010_R01?.telNo || ""} 
					editable={!isLocked} 
					name="telNo" 
					onChange={handleChange}
				/>
				<InputForm 
					title="팩스번호" 
					value={editSAL1010_R01?.faxNo || ""} 
					editable={!isLocked} 
					name="faxNo" 
					onChange={handleChange}
				/>      
        		<BRDiv />  
				<InputForm 
					title="e-mail" 
					value={editSAL1010_R01?.email || ""} 
					editable={!isLocked} 
					name="email" 
					onChange={handleChange}
				/>
        		<BRDiv />
       			<AddressForm
					post={editSAL1010_R01?.post || ""}
					address={editSAL1010_R01?.address || ""}
					detailAddress={editSAL1010_R01?.detailAddress || ""}
					editable={!isLocked}
					handleFoucsId={addressHandleFoucsId}
					onChange={handleChange}
					onSearchClick={handleAddressSearchClick}
				/>
				<BRDiv />

				<SingleDateForm
					title="납기일"
					value={new Date(editSAL1010_R01?.dueDt || new Date())}
					setValue={(value: Date | undefined) => handleDateChange('dueDt', formatDate(value))}
					editable={!isLocked}
					visible={dueDtVisible}
					setVisible={setDueDtVisible}
					onChange={handleChange}
					pickerPos={dueDtPickerPos}
					setPickerPos={setDueDtPickerPos}
				/>
				<BRDiv />
				<DropDownForm
					title="기본물류" 
					value={editSAL1010_R01?.logicCenter}
					name="logicCenter"
					initLabelLess={true}
					data={wmsCdList}
					editable={!isLocked}
					onChange={handleChange} 
				/>
				<BRDiv />
				<InputForm 
					title="수주금액" 
					value={editSAL1010_R01?.orderAmt || 0} 
					editable={false} 
					name="orderAmt" 
					onChange={handleChange} 
				/>
				<DropDownForm
					title="부가세구분" 
					value={editSAL1010_R01?.vatType}
					name="vatType"
					initLabelLess={true}
					data={vatTypeList}
					editable={!isLocked}
					onChange={handleChange} 
				/>
				<BRDiv />
				<InputForm	title="부가세" 
							value={editSAL1010_R01?.vatAmt ?? 0} 
							editable={!isLocked} 
							name="vatAmt" 
							onChange={handleChange}
						/>
        
				<InputForm	title="공급총액" 
							value={editSAL1010_R01?.totalAmt ?? 0} 
							editable={false} 
							name="totalAmt" 
							onChange={handleChange} 
							/>
				<BRDiv />
				<InputForm title="비고" value={editSAL1010_R01?.remark || ""} editable={!isLocked} wrapperOption={{
						wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[10px]",
						titleStyle: "w-[100px] min-w-[100px] text-left",
						inputStyle: "w-[510px] min-w-[510px]"
					}} name="remark" onChange={handleChange} />
		</div>
	)
}; 